enum AnswerAction {
    EVIDENCE = 'evidence',
    ACTION_PLAN = 'actionPlan',
    REPORT_FOLIO = 'reportFolio',
    RECOURRENCE_ALERT = 'residenceAlert',
}

export { AnswerAction }
